<template>
    <sections>
        <section-videos
            heading="Videos"
            content="<article-videos />"
            :videos="[
                {
                    platform: 'tiktok',
                    channel: '@laurenjones.dance',
                    video: '7278653867762437409',
                    heading: 'Let There Be Love',
                    excerpt: 'All-Star J&J at Bavarian Open 2023',
                },
                {
                    platform: 'tiktok',
                    channel: '@laurenjones.dance',
                    video: '7271717006343228705',
                    heading: 'Bury A Friend',
                    excerpt: 'All-Star J&J at Westie Spring Thing 2023',
                },
                {
                    platform: 'tiktok',
                    channel: '@laurenjones.dance',
                    video: '7272238135138962721',
                    heading: 'Sax',
                    excerpt: 'All-Star J&J at Baltic Swing 2023',
                },
                {
                    platform: 'tiktok',
                    channel: '@affinityswing',
                    video: '7276141380290792736',
                    heading: 'Macarena',
                    excerpt: 'Strictly Swing at Bavarian Open 2023',
                },
                {
                    platform: 'tiktok',
                    channel: '@affinityswing',
                    video: '7265033981685419296',
                    heading: 'Me Too',
                    excerpt: 'All-Star J&J at Midland Swing Open 2022',
                },
                {
                    platform: 'tiktok',
                    channel: '@affinityswing',
                    video: '7184560945673407749',
                    heading: 'The Mates of Soul',
                    excerpt: 'Strictly Swing at The After Party 2022',
                },
            ]"
        ></section-videos>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Videos | ' + $config.public.siteName,
    description: "Check out Lauren's most popular videos.",
    index: true,
});
</script>
